export default "__VITE_ASSET__5c1064c5__"